import { SelectOption } from './Select';
import { byTextAscending } from '../../utils/comparators';

export const toSelectOptions = (
  modelArray: any[] | undefined,
  labelField: string,
  firstEntryEmpty = true,
  sortable = false,
  labelFieldzusatz?: string
): SelectOption[] => {
  const selectOptions: SelectOption[] = [];
  if (modelArray) {
    if (firstEntryEmpty) {
      selectOptions.push({ elementId: 0, id: undefined, value: '' });
    }
    modelArray.forEach((modelObject, index) => {
      if (modelObject[labelField]) {
        selectOptions.push({
          elementId: index + (firstEntryEmpty ? 1 : 0),
          id: modelObject['id'],
          value: labelFieldzusatz
            ? `${modelObject[labelField]} - ${modelObject[labelFieldzusatz]}`
            : modelObject[labelField],
        });
      }
    });
  }

  if (sortable) {
    let selectedOptionSort = [...selectOptions];
    selectedOptionSort = selectedOptionSort.sort(
      byTextAscending((arr: SelectOption) => arr.value ?? ' ')
    );
    return selectedOptionSort;
  }
  return selectOptions;
};

export const toSelectOption = (
  model: any | undefined,
  labelField: string
): SelectOption => {
  if (model) {
    return { elementId: model.id, id: model.id, value: model[labelField] };
  }
  return { elementId: -1, id: 0, value: '' };
};
